'use strict'; // TODO: Remove from `core-js@4`

var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var lengthOfArrayLike = require('../internals/length-of-array-like');

var toAbsoluteIndex = require('../internals/to-absolute-index');

var toIntegerOrInfinity = require('../internals/to-integer-or-infinity');

var fails = require('../internals/fails');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var max = Math.max;
var min = Math.min; // some early implementations, like WebKit, does not follow the final semantic

var PROPER_ORDER = !fails(function () {
  // eslint-disable-next-line es-x/no-typed-arrays -- required for testing
  var array = new Int8Array([1]);
  var spliced = array.toSpliced(1, 0, {
    valueOf: function valueOf() {
      array[0] = 2;
      return 3;
    }
  });
  return spliced[0] !== 2 || spliced[1] !== 3;
}); // `%TypedArray%.prototype.toSpliced` method
// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toSpliced

exportTypedArrayMethod('toSpliced', function toSpliced(start, deleteCount
/* , ...items */
) {
  var O = aTypedArray(this);
  var C = getTypedArrayConstructor(O);
  var len = lengthOfArrayLike(O);
  var actualStart = toAbsoluteIndex(start, len);
  var argumentsLength = arguments.length;
  var k = 0;
  var insertCount, actualDeleteCount, convertedItems, newLen, A;

  if (argumentsLength === 0) {
    insertCount = actualDeleteCount = 0;
  } else if (argumentsLength === 1) {
    insertCount = 0;
    actualDeleteCount = len - actualStart;
  } else {
    actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    insertCount = argumentsLength - 2;

    if (insertCount) {
      convertedItems = new C(insertCount);

      for (var i = 2; i < argumentsLength; i++) {
        convertedItems[i - 2] = arguments[i];
      }
    }
  }

  newLen = len + insertCount - actualDeleteCount;
  A = new C(newLen);

  for (; k < actualStart; k++) {
    A[k] = O[k];
  }

  for (; k < actualStart + insertCount; k++) {
    A[k] = convertedItems[k - actualStart];
  }

  for (; k < newLen; k++) {
    A[k] = O[k + actualDeleteCount - insertCount];
  }

  return A;
}, !PROPER_ORDER);